import Marquee from "react-fast-marquee";

const items = [
  "EVERY TAIL MATTERS",
  "EVERY PAWPRINT LEAVES A MARK",
  "LOVE FOR ALL ANIMALS",
];

export const EditorialMarquee = () => {
  return (
    <div
      className="relative z-10 bg-[#E07A5F] py-6 overflow-hidden"
      data-testid="marquee"
    >
      <Marquee speed={40} gradient={false}>
        {[...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl sm:text-3xl font-medium text-[#FDFBF7] mx-8 flex items-center gap-8"
          >
            {t}
            <span className="text-[#F2CC8F]">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
